var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreHunt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Puan Av\\u0131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF8A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35A0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ph-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0700F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ph-red",
    cx: 0.4,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2172A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ph-white",
    cx: 0.4,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EBF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-coin",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7C230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D08A07"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ph-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ph-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#5A1E00",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ph-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#7A2E00",
    opacity: 0.38,
    filter: "url(#ph-bsh)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#B84A05",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ph-face)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#C2500A",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#ph-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ph-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#ph-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ph-osh)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 278,
    r: 120,
    fill: "#8F1520"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 270,
    r: 120,
    fill: "url(#ph-red)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 270,
    r: 96,
    fill: "url(#ph-white)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 270,
    r: 72,
    fill: "url(#ph-red)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 270,
    r: 48,
    fill: "url(#ph-white)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 270,
    r: 24,
    fill: "url(#ph-red)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,206 A110,110 0 0 1 222,162",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.55,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,266 L302,204",
    stroke: "#2F3448",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,270 L246,252 L254,260 Z",
    fill: "#2F3448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,208 L336,202 L320,186 Z",
    fill: "#2A8CF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,208 L304,170 L320,186 Z",
    fill: "#5DB1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 341,
    r: 46,
    fill: "#A86A05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 334,
    r: 46,
    fill: "url(#ph-coin)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 334,
    r: 35,
    fill: "none",
    stroke: "#FFF2B0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338,
    cy: 312,
    rx: 18,
    ry: 8,
    fill: "#FFFFFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(354 336)",
    fill: "none",
    stroke: "#A86A05",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6,-24 L-6,22 C12,22 22,10 22,-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18,-1 L12,-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18,11 L12,-1"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(384 186) scale(16)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(118 380) scale(10)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreHunt);
export default __webpack_public_path__ + "static/media/score-hunt.3acbadc732bd8fdb75ca0824177ae256.svg";
export { ForwardRef as ReactComponent };